import { connect } from 'react-redux'

import { getCountryLabel } from '../../../../../../redux/collaborativeIndexations/selectors'
import { Country } from './Country.jsx'

const mapStateToProps = (state) => ({
    getLabel: value => getCountryLabel(state, value),
})

export const CountryContainer = connect(
    mapStateToProps,
)(Country)
